import { Dialog, Stack } from '@mui/material';
import { ActionButton, DialogHeading, DialogText } from './styles';
import { Restore } from '@mui/icons-material';

export const RestoreConfirmationDialog = ({
  open,
  handleClose,
  handleConfirm,
  loading,
}: {
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
  loading: boolean;
}) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          maxWidth: '52.6rem',
          padding: '2.4rem',
          borderRadius: '0.8rem',
        },
      }}
    >
      <Stack gap="1.6rem">
        <Stack direction="row" alignItems="center" gap="0.8rem">
          <Restore />
          <DialogHeading>Restore Version</DialogHeading>
        </Stack>
        <DialogText>
          Restoring to the selected version will make it the latest version. All subsequent versions
          will be deleted, and history will be erased.
        </DialogText>
      </Stack>
      <Stack direction="row" justifyContent="flex-end">
        <Stack direction="row" alignItems="center" gap="1.6rem" mt="2.4rem">
          <ActionButton onClick={handleClose}>CANCEL</ActionButton>
          <ActionButton contained onClick={handleConfirm} disabled={loading}>
            CONTINUE
          </ActionButton>
        </Stack>
      </Stack>
    </Dialog>
  );
};
